import React from 'react';
import * as styles from './PricingCheckIcon.module.scss';
import SVGIcon from '../components/SVGIcon';
import checkIcon from '../icons/non-prefilled/16x16/check.svg';

const PricingCheckIcon = () => {
  return <SVGIcon className={styles.checkIcon}>{checkIcon}</SVGIcon>;
};

export default PricingCheckIcon;
